import {
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { SimpleChange, SimpleChanges } from '@angular/core';
import { mockAddress } from './address.mocks';
import {
  mockSubscriber,
  mockSpouse,
  mockChildDependents,
  mockAdultDependents,
} from './dependents.mocks';

export const {
  email,
  phone,
  home_phone,
  date_of_birth,
  email_address,
  primary_phone,
  ...mockSubscriberMember
} = mockSubscriber;

export const mockMemberFormGroupValue = new UntypedFormGroup({
  subscriber: new UntypedFormControl({
    ...mockSubscriberMember,
    date_of_birth: '1999-02-23',
    address: mockAddress,
  }),
  spouse: new UntypedFormControl({
    ...mockSpouse,
    address: mockAddress,
  }),
  children: new UntypedFormArray([
    new UntypedFormControl({
      ...mockChildDependents[0],
      medicare_enrolled: 'false',
      address: mockAddress,
    }),
  ]),
  stepParents: new UntypedFormArray([
    new UntypedFormControl({
      ...mockAdultDependents[0],
      medicare_enrolled: 'false',
      address: mockAddress,
    }),
  ]),
});

export const mockDataCoverageCardFooterChanges: SimpleChanges = {
  memberFormGroupValue: new SimpleChange(null, mockMemberFormGroupValue, true),
};
